import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-navy-soft px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pj6ds81asqsl">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-20" data-mp="avcvugoqpc6u">
          5 PREMIUM <span className="bg-gold px-1 text-navy" data-id="element-21" data-mp="fsv74dq8c3i0">BONUSES INCLUDED</span>
        </h2>
        <div className="mt-2 space-y-1.5" data-id="element-22" data-mp="1tc1brkw548v">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-4 border-gold bg-navy px-2.5 py-2" data-id="element-23" data-mp="5wi76y43ctet">
              <h3 className="font-display text-[0.68rem] font-extrabold uppercase leading-tight text-gold sm:text-[0.86rem]" data-id="element-24" data-mp="3o2epo2niut6c">
                🎁 BONUS {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-white/80 sm:text-[0.92rem]" data-id="element-25" data-mp="1m9yvtb7sksx0">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}